import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCallHistoryReasonSlice = (set, get) => ({
    crmCallHistoryReason: {
        loading: false,
        data: []
    },
    getCrmCallHistoryReason: async (id) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmCallHistoryReason: { ...state.crmCallHistoryReason, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/call-history/${id}`,
                headers: { token }
            });
            set(state => ({ crmCallHistoryReason: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmCallHistoryReason: { ...state.crmCallHistoryReason, loading: false } }));
        }
    }
});
